import apiClient from "./apiClient";


export const getAllClients = async () => {

    const response = await apiClient.get(
        "/client/getall"
    );

    return response.data;

};